<template>
  <el-row class="container-card">
    <el-col>
      <div class="flex-start profile-tabs position-relative">
        <div
          class="profile-tab pointer"
          :class="{ active: activeCard === item }"
          @click="activeCard = item"
          v-for="(item, i) in tabs"
          :key="i"
        >
          <p>{{ item }}</p>
        </div>
      </div>
      <el-card class="data">
        <div
          class="profile-content flex-space-between"
          v-if="activeCard === 'Description'"
        >
          <div class="bio">
            <el-form>
              <el-form-item prop="description">
                <vue-editor
                  v-model="description"
                  :editorToolbar="customToolbar"
                />
              </el-form-item>
            </el-form>
            <el-button
              type="primary"
              class="btn-main float-right ml-auto"
              @click="submitDescription"
            >
              Save
            </el-button>
          </div>
        </div>
        <div
          class="profile-content flex-space-between"
          v-if="activeCard === 'Agreements'"
        >
          <div>
            <el-button type="primary" class="btn-main float-right ml-auto">
              Save
            </el-button>
          </div>
        </div>
        <div
          class="profile-content flex-space-between"
          v-if="activeCard === 'Social Networks'"
        >
          <div class="social-networks">
            <el-form>
              <el-form-item
                prop="website"
                label="Website"
                :label-width="formLabelWidth"
              >
                <el-input autocomplete="off" v-model="website.url"></el-input>
              </el-form-item>
              <el-form-item
                prop="instagram"
                label="Instagram"
                :label-width="formLabelWidth"
              >
                <el-input autocomplete="off" v-model="instagram.url"></el-input>
              </el-form-item>
              <el-form-item
                prop="facebook"
                label="Facebook"
                :label-width="formLabelWidth"
              >
                <el-input autocomplete="off" v-model="facebook.url"></el-input>
              </el-form-item>
              <el-form-item
                prop="twitter"
                label="Twitter"
                :label-width="formLabelWidth"
              >
                <el-input autocomplete="off" v-model="twitter.url"></el-input>
              </el-form-item>
              <el-form-item
                prop="youtube"
                label="YouTube Channel"
                :label-width="formLabelWidth"
              >
                <el-input autocomplete="off" v-model="youtube.url"></el-input>
              </el-form-item>
              <el-form-item
                prop="soundcloud"
                label="SoundCloud Page"
                :label-width="formLabelWidth"
              >
                <el-input
                  autocomplete="off"
                  v-model="soundcloud.url"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="toktok"
                label="TikTok Page"
                :label-width="formLabelWidth"
              >
                <el-input autocomplete="off" v-model="tiktok.url"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <el-button type="primary btn-main" @click="submitSocial"
            >Save</el-button
          >
        </div>
        <div
          class="profile-content flex-space-between"
          v-if="activeCard === 'Team Members'"
        >
          <div>
            <p class="title">Team Account Access</p>
            <p>
              Account team members will have access to your artist folders,
              marketing pages,<br />
              ad campaigns and some settings
            </p>
            <div class="flex-start">
              <p class="title mr10">Members</p>
              <p>(2/3 used)</p>
              <el-button type="primary" class="btn-main float-right ml-auto">
                + Add member
              </el-button>
            </div>
            <div
              class="member flex-start"
              v-for="(member, index) in members"
              :key="index"
            >
              <img src="@/assets/images/member.svg" alt="" />
              <div>
                <p class="name">{{ member.name }}</p>
                <p class="email">{{ member.email }}</p>
              </div>
              <p class="status" v-if="member.active == 1">Active</p>
            </div>
          </div>
        </div>
        <div
          class="profile-content flex-space-between"
          v-if="activeCard === 'Help Desk'"
        >
          <div class="help-desk">
            <el-form>
              <el-form-item>
                <el-input
                  placeholder="Subject"
                  autocomplete="off"
                  v-model="subject"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  class="textarea"
                  type="textarea"
                  placeholder="Text"
                  autocomplete="off"
                  maxlength="255"
                  v-model="text"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button
              type="primary"
              class="btn-main float-right ml-auto"
              @click="submitMessage"
            >
              Submit
            </el-button>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      subject: '',
      text: '',
      url: process.env.VUE_APP_STORAGE_URL,
      activeCard: 'Description',
      tabs: [
        'Description',
        //'Agreements',
        'Social Networks',
        //'Team Members',
        'Help Desk'
      ],
      formLabelWidth: '165px',
      members: [
        {
          name: 'Jessica Paine',
          email: 'email@oooooo.com',
          active: 1
        },
        {
          name: 'Joe Little',
          email: 'email@ssssss.com',
          active: 1
        },
        {
          name: 'Marina Karamarko',
          email: 'email@uuuuuu.com',
          active: 1
        }
      ],
      description: '',
      website: {
        id: 0,
        url: '',
        name: 'Website'
      },
      instagram: {
        id: 0,
        url: '',
        name: 'Instagram'
      },
      facebook: {
        id: 0,
        url: '',
        name: 'Facebook'
      },
      twitter: {
        id: 0,
        url: '',
        name: 'Twitter'
      },
      youtube: {
        id: 0,
        url: '',
        name: 'YouTube'
      },
      soundcloud: {
        id: 0,
        url: '',
        name: 'SoundCloud'
      },
      tiktok: {
        id: 0,
        url: '',
        name: 'TikTok'
      }
    }
  },

  created() {
    this.readLabel().then(() => {
      this.description = this.label.description
      this.label.social.map(s => {
        if (s.type.name == 'Website') {
          this.website.id = s.id
          this.website.url = s.url
        }
        if (s.type.name == 'Instagram') {
          this.instagram.id = s.id
          this.instagram.url = s.url
        }
        if (s.type.name == 'Facebook') {
          this.facebook.id = s.id
          this.facebook.url = s.url
        }
        if (s.type.name == 'Twitter') {
          this.twitter.id = s.id
          this.twitter.url = s.url
        }
        if (s.type.name == 'YouTube') {
          this.youtube.id = s.id
          this.youtube.url = s.url
        }
        if (s.type.name == 'SoundCloud') {
          this.soundcloud.id = s.id
          this.soundcloud.url = s.url
        }
        if (s.type.name == 'TikTok') {
          this.tiktok.id = s.id
          this.tiktok.url = s.url
        }
      })
    })
  },

  computed: {
    ...mapState('labelMyProfile', ['label'])
  },

  methods: {
    ...mapActions('labelMyProfile', [
      'readLabel',
      'updateDescription',
      'updateSocial',
      'sendMessage'
    ]),
    submitDescription() {
      this.updateDescription(this.description)
    },
    submitSocial() {
      let social = [
        this.website,
        this.instagram,
        this.facebook,
        this.twitter,
        this.youtube,
        this.soundcloud,
        this.tiktok
      ]
      this.updateSocial(social)
    },
    submitMessage() {
      let fullMessage = {
        subject: this.subject,
        text: this.text
      }
      this.sendMessage(fullMessage)
      this.text = ''
      this.subject = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-tabs {
  height: 58px;
  .profile-tab {
    width: 190px;
    height: 70px;
    background: white;
    display: flex;
    justify-content: center;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    z-index: 1;
    box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.17);
    font-family: 'F37 Ginger Pro Bold';
    &.active {
      background: #e6e5e8;
      color: #d40c41;
    }
  }
}

.data {
  z-index: 2;
  position: relative;
  height: 560px;
}

.profile-content {
  padding: 0 30px;
  p {
    font-size: 16px;
  }
  p.title {
    font-size: 20px;
    font-family: 'F37 Ginger Pro Bold';
  }
  .social-networks {
    width: 86%;
  }
  .help-desk {
    width: 86%;
  }
  .btn-main {
    align-self: flex-end;
    margin-bottom: 8px;
  }
  .member {
    width: 100%;
    height: 65px;
    border-radius: 10px;
    border: 1px solid grey;
    margin-bottom: 6px;
    img {
      padding: 0 20px;
    }
    p {
      margin: 0;
    }
    .email,
    .status {
      font-size: 12px;
    }
    .status {
      margin-left: auto;
      padding-right: 65px;
    }
  }
}
</style>
